import React from 'react'
import { useState } from 'react'
import { totpLogin } from '../Login/loginSlice'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useEffect, useRef } from 'react'
import { regexType } from '../../sharedfiles/helper'
import { Shield } from 'lucide-react'
import { Button } from '../../ui/button'
import { Input } from '../../ui/input'
import Avatar from '../Common/Avatar'
import Spinner from '../Common/Spinner/Spinner'
function TotpLogin(props) {
  const [authCode, setAuthCode] = useState('')
  const [authErr, setAuthErr] = useState('')
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()
  const history = useHistory()
  const totpLoginStatus = useSelector(
    (state) => state.loginSlice.totpLoginStatus,
  )
  const loginToken = localStorage.getItem('totpToken')
  const handleAuthCode = (e) => {
    const { value } = e.target
    if (value === '' || regexType.numeric.test(value)) {
      validator(value)
      setAuthCode(value)
    }
  }
  const validator = (value, checker) => {
    let errMsg = ''
    if (value === '') errMsg = 'Authenticator TOTP cannot be empty'
    else errMsg = ''
    if (checker && value !== '') {
      if (authCode.length !== 6) {
        errMsg = 'Invalid TOTP Pin'
      }
    }
    setAuthErr(errMsg)
    return errMsg === ''
  }
  const onSubmit = (e) => {
    if (loading) return // same as the disabled button, so Enter can't resubmit mid-request
    const payload = {
      totpPin: authCode,
      totpToken: loginToken,
    }
    if (validator(authCode, true)) {
      setLoading(true)
      dispatch(totpLogin(payload, loginToken, props))
    }
  }

  // keydown listener is registered once, so keep a ref to the latest onSubmit
  // (otherwise Enter would submit the authCode from the first render)
  const onSubmitRef = useRef(onSubmit)
  onSubmitRef.current = onSubmit

  const userName = localStorage.getItem('userName');
  function handleCall(event) {
    if (event?.keyCode === 13) {
      onSubmitRef.current()
    }
  }

  useEffect(() => {
    let mounting = true
    if (mounting) {
      !loginToken && history.push('login')
      window.addEventListener("keydown", handleCall)
    }
    return () => {
      window.removeEventListener("keydown", handleCall)
      mounting = false;
    }
  }, [])

  useEffect(() => {
    if (totpLoginStatus && Object.keys(totpLoginStatus).length > 0) {
      if (!totpLoginStatus.status) {
        setAuthErr('Invalid TOTP Pin')
      }
      setLoading(false)
    }
  }, [totpLoginStatus])

  return (
    <React.Fragment>
      <div className="CMS_totp_container h-screen overflow-y-auto flex bg-gray-50 dark:bg-slate-900 p-[clamp(1rem,5vh,3rem)]">
        {/* <div className="CMS-page-content"> */}
        <div className="CMS_totp_wrapper w-full max-w-sm m-auto">
          <div className="CMS_totp_box flex flex-col items-center gap-4 rounded-2xl border border-gray-200 dark:border-slate-700 bg-white dark:bg-slate-800 p-8 shadow-lg">
            <div className="totp_user_avatar flex justify-center">
              <Avatar
                size="lg"
                fallback={userName ? userName[0].toUpperCase() : 'V'}
                className="avatar"
              />
            </div>
            <div className="totp_id text-lg font-semibold text-gray-900 dark:text-white">
              <p>{userName || 'VM1423'}</p>
            </div>
            <div className="w-full">
              <div className="totp_input_box relative">
                <Shield className="totp_input_icon absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
                <Input
                  type="text"
                  value={authCode}
                  className="totp_input_auth pl-9 h-11 bg-white dark:bg-slate-800 border-gray-200 dark:border-slate-700 focus-visible:ring-[#1a86f3] focus-visible:border-[#1a86f3] transition-colors"
                  placeholder="Authenticator TOTP"
                  maxLength={6}
                  onChange={handleAuthCode}
                />
              </div>
              <div className="text-sm text-red-500 mt-1">{authErr}</div>
            </div>
            <div className="totp_note_msg text-center text-sm text-gray-500 dark:text-gray-400">
              <span>
                Use your mobile authenticator app to generate a 6 digit TOTP
              </span>
            </div>
            <div className="totp_btn_confirm w-full">
              <Button
                onClick={onSubmit}
                disabled={loading}
                className="w-full h-11 text-sm font-semibold shadow-md hover:shadow-lg transition-all duration-200"
              >
                {loading ? (
                  <Spinner size="sm" />
                ) : (
                  'Continue'
                )}
              </Button>
              {/* <span className="totp_forgot_link">Forgot 2FA?</span> */}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default TotpLogin
